module.exports = __webpack_public_path__ + "media/images/PrepWorks-Logo-67eb881bd06830926e24d609ba087c6f.svg";